import React, { useEffect, useState } from 'react';
import ConfirmMailContent from 'components/authentication/ConfirmMailContent';
import { useLocation, useNavigate } from 'react-router-dom';
import {confirm, isActivation} from '../../../lib/api/user';

const ConfirmMail = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const activation_guide = queryParams.get('activation_guide'); // čita parametar iz URL-a

    const [items, setItems] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (activation_guide) {
            fetchData();
        }
    }, [activation_guide]);

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await isActivation({ activation_guide });
            setItems(response);
            console.log('response', response);
        } catch (error) {
            console.error('Greška prilikom učitavanja podataka:', error);
            navigate('/errors/404');
        }
        setLoading(false);
    };

    return (
        <div className="text-center">
            {loading ? (
                <p>Aktivacija u toku...</p>
            ) : items ? (
                <ConfirmMailContent link={'/authentication/simple/reset-password?activation_guide='+activation_guide|| '#'} />
            ) : (
                <p>Došlo je do greške</p>
            )}
        </div>
    );
};

export default ConfirmMail;
